import List from 'src/storage/list';
import { userFullName } from 'src/helpers';

import frontBookConfig from './config.front';

export class AccountsModel extends List {
  constructor(config = frontBookConfig) {
    super();
    this.config = config;
    this.id = config.accountModelId;
    this.apiConfig = {
      ...this.apiConfig,
      savePatient: { ...this.apiConfig.savePatient, url: config.api.invitePatient }
    };
  }

  defaultState = () => ({
    current: 'recent',
    patient: null,
    phoneNumber: null
  });

  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = {
    key: 'date',
    desc: true
  };
  apiConfig = {
    refresh: {
      url: 'account/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'onLoaded'
    },
    list: {
      url: 'account/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'onLoaded'
    },
    search: {
      url: 'account/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'onLoaded'
    },
    savePatient: {
      url: 'invitation/send/patient',
      validation: {
        email: 'email',
        fullname: 'fullName',
        phoneNumber: 'phoneNumber',
        firstName: 'firstName',
        lastName: 'lastName',
        gender: 'gender',
        birthday: 'birthday',
        countryAddress: 'countryAddress',
        cityAddress: 'cityAddress',
        stateAddress: 'stateAddress',
        address: 'address',
        zipcode: 'zipcode'
      },
      cancellable: true
    }
  };

  listParams(loadMore) {
    const req = {
      skip: 0,
      limit: this.listLimit,
      prioritizeRole: 'patient',
      queryByPhoneNumber: true
    };
    const query = this.listInput('search');

    if (query.length > 0) {
      req.query = query;
    } else {
      return null;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }

  getEditFields = (patient) => ({
    patientId: patient.id || null,
    email: patient.email || '',
    firstName: patient.firstName || '',
    lastName: patient.lastName || '',
    gender: patient.gender || 'other',
    birthday: patient.birthday || '',
    address: patient.address || '',
    countryAddress: patient.countryAddress || '',
    stateAddress: patient.stateAddress || '',
    cityAddress: patient.cityAddress || '',
    zipcode: patient.zipcode || ''
  });

  savePatient = (cb) => {
    let { firstName, lastName } = this.state;
    let fullname = userFullName(this.state);

    let req = {
      id: this.state.patientId,
      fullname,
      firstName,
      lastName,
      gender: this.state.gender,
      birthday: this.state.birthday,
      countryAddress: this.state.countryAddress || '',
      cityAddress: this.state.cityAddress || '',
      stateAddress: this.state.stateAddress || '',
      phoneNumber: this.state.phoneNumber,
      email: this.state.email,
      address: this.state.address,
      zipcode: this.state.zipcode?.toString() || '',
      type: 'advanced'
    };
    this.api('savePatient', req, (err, data) => {
      cb && cb(this.config.parseInviteResult(data));
    });
  };
}

// Default instance for the front app (kept so existing imports keep working)
const model = new AccountsModel(frontBookConfig);
export default model;
